import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import SystemUpdateAltSharpIcon from '@material-ui/icons/SystemUpdateAltSharp';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import MUIDataTable from "mui-datatables";
//import { tr } from "date-fns/esm/locale";
import Typography from "@material-ui/core/Typography";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CircularProgress from '@material-ui/core/CircularProgress';
//import Modal from '@material-ui/core/Modal';
//import { makeStyles } from '@material-ui/core/styles';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';

import MaterialTable from 'material-table';

export class UploadFilePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            projects: [],
            filename: "",
            //documentTitle: "",
            dataDocs: [],
            userType: -1,
            isFetching: false,
            isUploading: false,
            fileCategory: "",

            uploadFreeFormCategories: [
                { TypeId: 4, TypeName: "Action Level" },
                { TypeId: 3, TypeName: "Sector Level" },
                { TypeId: 2, TypeName: "Strategic Level" },
                { TypeId: 1, TypeName: "Other" },
            ],

            modalDeleteOpen: false,
            idFileUploadDelete: 0,
        };
    }

    componentDidMount() {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        this.loadPageProjects();
        this.loadFreeFormOnlyFiles();
        this.getUserType();
    }

    loadPageProjects = async () => {
        let pageData = { operation: "GetListOfAllProjects" };

        await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFALLPROJECTS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ projects: result.projects });
            });
    }

    loadFreeFormOnlyFiles = async () => {
        let pageData = { operation: "LoadFreeFormOnlyFiles" };

        await fetch(global.variables.API_UPLOADFILESPAGE_GETFREEFORMONLYFILES, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                var resultDataDocuments = result.freeformonlyfiles;

                for (var i = 0; i < resultDataDocuments.length; i++) {
                    resultDataDocuments[i].FreeFormCategoryName =
                        this.returnArrayElement(this.state.uploadFreeFormCategories,
                            resultDataDocuments[i].FreeFormCategory).TypeName
                }

                this.setState({ dataDocs: resultDataDocuments });
                //this.setState({ dataDocs: result.freeformonlyfiles });
            });
    }

    onChangeFile = (event) => {
        //this.setState({
        //    file: e.target.files[0],
        //    filename: e.target.files[0].name
        //});

        //var filesvar = this.state.files;
        var filesvar = [];
        filesvar.push({
            filename: event.target.name,
            fileblob: event.target.files[0]
        });
        this.setState({ files: filesvar });

        this.setState({ filename: event.target.files[0].name });
    };

    doUpload = async () => {

        if (this.state.filename == "" || this.state.filename == null ||
            this.state.documentTitle == "" || this.state.documentTitle == null ||
            this.state.fileCategory == "" || this.state.fileCategory == null) {

            toast.warn("Please fill in the required inputs.", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            return;
        }

        await this.setState({ isFetching: true, isUploading: true });

        console.log(this.state);

        var formData = new FormData();

        if (this.state.files && this.state.files.length > 0) {
            var filesarray = this.state.files;
            for (var i = 0; i < filesarray.length; i++) {
                //console.log("Appending files " + filesarray[i].filename);
                formData.append(filesarray[i].filename, filesarray[i].fileblob);
            }
        }

        var postData = this.state;
        Object.keys(postData).forEach((key, value) => {
            if (key !== "files" & key !== "projects") {
                formData.append(key, postData[key]);
            }
        });

        //console.log("DoUpload");
        //for (var pair of formData.entries()) {
        //    console.log(pair[0] + ', ' + pair[1]);
        //}

        await fetch(global.variables.API_UPLOADFILESPAGE_UPLOADFREEFORMFILES, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                //Accept: "application/json",
                //"Content-Type": "application/json"
            },
            body: formData
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });

                    this.loadFreeFormOnlyFiles();
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                //this.pageLoad();
            });

        await this.setState({ isFetching: false, isUploading: false });
    }

    handleChange = async (e) => {
        //console.log(e);
        e.persist();
        await this.setState({ [e.target.name]: e.target.value });
    };

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectChangeUseValue = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeName });
        } else {
            await this.setState({ [vname]: "" });
        }

        console.log(this.state);
    }

    handleProjectSelectChange = (e, v) => {
        console.log(v)
        e.persist();

        if (v !== undefined & v !== null) {
            this.setState({
                selectedProjectId: v.idProjectDetails,
                selectedProject: v
            });
        } else {
            this.setState({
                selectedProjectId: -1,
                selectedProject: null
            });
        }
    }

    //handleFileUploadDelete = (val) => {
    //    console.log(val);

    //    if (val !== undefined & val !== null) {

    //        this.loadFreeFormWithProjectFiles();
    //    } else {

    //    }
    //}

    //handleFileUploadDelete = (val) => {
    handleFileUploadDelete = async () => {
        //console.log(val);
        var val = this.state.idFileUploadDelete;

        if (val !== undefined & val !== null & val !== 0) {
            await this.setModalDeleteOpenToggle();

            await this.handleDeleteFreeFormOnlyFiles(val);

            await this.loadFreeFormOnlyFiles();
        } else {
            await this.setModalDeleteOpenToggle();
        }

        //window.location.reload();
    }

    handleFileUploadDeleteConfirmation = async (val) => {
        console.log("handleFileUploadDeleteConfirmation " + val);

        await this.setState({ idFileUploadDelete: val });

        await this.setModalDeleteOpenToggle();
    }

    handleDeleteFreeFormOnlyFiles = async (val) => {

        await this.setState({ isFetching: true, isUploading: true });

        let pageData = {
            operation: "DeleteFreeFormOnlyFiles",
            freeformfileid: val,
        };

        //console.log(pageData);

        await fetch(global.variables.API_UPLOADFILESPAGE_DELETENONPROJECTFREEFORMFILES, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                //this.setState({ dataDocuments: result.freeformwithprojectfiles });
            });

        await this.setState({ isFetching: false, isUploading: true });
    }

    handleDoDownloadHrefName = (hrefUrl, fileName) => {
        console.log("Download " + fileName + " " + hrefUrl);
        var a = document.createElement('a');
        a.href = hrefUrl;
        a.download = fileName;
        console.log(a);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    setModalDeleteOpenToggle = async () => {
        //var o = modalDeleteOpen;

        await this.setState({ modalDeleteOpen: !this.state.modalDeleteOpen });
        //await this.setState({ modalDeleteOpen: true });
    }

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId == element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    returnArrayElementUseValue = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeName == element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    render() {

        const {
            projects,
            dataDocs,
            userType,
            isFetching,
            isUploading,
            fileCategory,
            uploadFreeFormCategories,
            modalDeleteOpen,
        } = this.state;

        //const projects = [
        //    { title: "Project 1", no: 1 },
        //    { title: "Project 2", no: 2 },
        //    { title: "Project 3", no: 3 },
        //    { title: "Project 4", no: 4 },
        //    { title: "Project 5", no: 5 }
        //];

        //const categories = [
        //    { title: "MR", no: 1 },
        //    { title: "MQ", no: 2 },
        //    { title: "Quality Checklist", no: 3 },
        //    { title: "Draft Template for Meeting Schedule", no: 4 }
        //];

        //const columns = [
        //    {
        //        name: "Title",
        //        options: {
        //            filter: true,
        //            sort: true
        //        }
        //    },

        //    {
        //        name: "Category",
        //        options: {
        //            filter: true,
        //            sort: true
        //        }
        //    },
        //    {
        //        name: "Upload Date",
        //        options: {
        //            filter: true,
        //            sort: true
        //        }
        //    },
        //    {
        //        name: "Size",
        //        options: {
        //            filter: true,
        //            sort: true
        //        }
        //    },
        //    {
        //        name: "Actions",
        //        options: {
        //            filter: false,
        //            sort: false,
        //            customBodyRender: (value, tableMeta, updateValue) => {
        //                return (
        //                    <div>
        //                        {
        //                            //<Button variant="outlined" color="primary">
        //                            //    Edit
        //                            //</Button>
        //                        }
        //                        <Button
        //                            style={{ marginLeft: 5 }}
        //                            variant="outlined"
        //                            color="secondary"
        //                        >
        //                            Delete
        //                        </Button>
        //                    </div>
        //                );
        //            }
        //        }
        //    }
        //];

        const columns = [
            {
                name: "idFreeFormFiles",
                options: {
                    display: false
                }
            },
            {
                name: "DocumentTitle",
                label: "Document Title",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "UploadDatetime",
                label: "Date and Time",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "FreeFormCategoryName",
                label: "File Category",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "fkUploadedFiles",
                options: {
                    display: false
                }
            },
            {
                name: "OriginalFilename",
                options: {
                    display: false
                }
            },
            //{
            //    name: "d",
            //    options: {
            //        filter: true,
            //        sort: true
            //    }
            //},
            //{
            //    name: "s",
            //    options: {
            //        filter: true,
            //        sort: true
            //    }
            //},
            {
                name: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {

                        //console.log(tableMeta.rowData[3])
                        return (
                            <div>
                                <Button
                                    style={{
                                        width: 117,
                                        height: 37,
                                        marginLeft: 5
                                    }}
                                    variant="outlined"
                                    color="primary"
                                    component="a"
                                    href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + tableMeta.rowData[4]}
                                    //download={tableMeta.rowData[1]}
                                    download={tableMeta.rowData[5]}
                                    //target="_blank"
                                    disabled={isFetching ? true : false}
                                >
                                    Download
                                </Button>
                                {
                                    //<Button variant="outlined" color="primary">
                                    //    Edit
                                    //</Button>
                                }
                                <Button
                                    style={{
                                        width: 117,
                                        height: 37,
                                        marginLeft: 5,
                                        display: userType === 2 ? "block" : "none"
                                    }}
                                    variant="outlined"
                                    color="secondary"
                                    //onClick={() => this.handleFileUploadDelete(tableMeta.rowData[0])}
                                    onClick={() => this.handleFileUploadDeleteConfirmation(tableMeta.rowData[0])}
                                    disabled={isFetching ? true : false}
                                >
                                    Delete
                                </Button>
                            </div>
                        );
                    }
                }
            }
        ];

        //const data = [
        //    ["Document-1", "MR", "06/11/2019", "35Mb"],
        //    ["Document-2", "MR", "06/11/2019", "35Mb"],
        //    ["Document-3", "MR", "06/11/2019", "35Mb"],
        //    ["Document-4", "MR", "06/11/2019", "35Mb"]
        //];

        //const datas = [
        //    { "id": 1, "DocumentTitle": "Document-1", "UploadDatetime": "06/11/2019", "link": "abc" },
        //    { "id": 2, "DocumentTitle": "Document-2", "UploadDatetime": "06/11/2019", "link": "abc2" },
        //];

        const options = {
            //filter: false,
            filterType: "checkbox"
        };


        const actionsAdmin =
            [
                {
                    icon: () => <SystemUpdateAltSharpIcon />, // 'info', // <SystemUpdateAltSharpIcon />
                    tooltip: 'Download',
                    onClick: (event, rowData) => {
                        this.handleDoDownloadHrefName("/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + `/${rowData.fkUploadedFiles}`,
                            `${rowData.OriginalFilename}`);

                        //this.props.history.push("/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + `/${rowData.fkUploadedFiles}`);
                    },
                },
                {
                    icon: () => <DeleteOutlineIcon />,
                    tooltip: 'Delete',
                    onClick: (event, rowData) => {
                        //this.props.history.push(`/cycleofthereport/${rowData.idFreeFormFiles}`);
                        //this.handleFileUploadDeleteConfirmation(`${rowData.idFreeFormFiles}`);
                        this.handleFileUploadDeleteConfirmation(rowData.idFreeFormFiles);
                    },
                }
            ];


        const actionsNotAdmin =
            [
                {
                    icon: () => <SystemUpdateAltSharpIcon />, // 'info', // <SystemUpdateAltSharpIcon />
                    tooltip: 'Download',
                    onClick: (event, rowData) => {
                        this.handleDoDownloadHrefName("/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + `/${rowData.fkUploadedFiles}`,
                            `${rowData.OriginalFilename}`);

                        //this.props.history.push("/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + `/${rowData.fkUploadedFiles}`);
                    },
                }
            ];


        return (
            <Grid container spacing={3}>
                <Grid>
                    <ToastContainer />
                </Grid>
                <Grid item xs={12} className="mt-1">
                    {
                        //<Button variant="primary" onClick={() => this.setModalDeleteOpen()}>
                        //    Launch demo modal
                        //</Button>
                    }

                    <Modal show={modalDeleteOpen} onHide={() => this.setModalDeleteOpenToggle()} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Confirmation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Are you sure you want to delete?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => this.handleFileUploadDelete()}>
                                Delete
                            </Button>
                            <Button variant="primary" onClick={() => this.setModalDeleteOpenToggle()}>
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Grid>
                <Grid item xs={12} style={{ display: userType === 2 ? "block" : "none" }} >
                    <Card>
                        <CardHeader
                            title="Upload New File"
                            className="romis-card-header"
                        ></CardHeader>
                        <CardContent>
                            <input
                                //accept="*/*"
                                style={{ display: "none" }}
                                id="contained-button-file"
                                //multiple
                                type="file"
                                //fullwidth="true"
                                onChange={this.onChangeFile}
                                name="freeFormFile"
                            />
                            <label htmlFor="contained-button-file" style={{ width: "100%" }}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="large"
                                    component="span"
                                    fullWidth
                                    startIcon={<AttachFileIcon />}
                                    disabled={isFetching ? true : false}
                                >
                                    Select File
                                </Button>
                            </label>
                            <Typography
                                variant="caption"
                                component="h2"
                                style={{
                                    display: "none" ? this.state.filename === "" : "block"
                                }}
                            >
                                {this.state.filename}
                            </Typography>

                            <TextField
                                name="documentTitle"
                                label="Document Title"
                                fullWidth
                                margin="normal"
                                onChange={this.handleChange}
                            />

                            <Autocomplete
                                options={uploadFreeFormCategories}
                                getOptionLabel={option => option.TypeName}
                                autoComplete
                                includeInputInList
                                onChange={(e, v) => this.handleSelectChange(e, v, "fileCategory")}
                                value={this.returnArrayElement(uploadFreeFormCategories, fileCategory)}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        name={fileCategory}
                                        label="Select Category"
                                        placeholder="File Category"
                                        margin="normal"
                                        fullWidth
                                    />
                                )}
                            />

                            {
                                //<Autocomplete
                                //    options={categories}
                                //    getOptionLabel={option => option.title}
                                //    autoComplete
                                //    includeInputInList
                                //    renderInput={params => (
                                //        <TextField
                                //            {...params}
                                //            label="Select Category"
                                //            margin="normal"
                                //            fullWidth
                                //        />
                                //    )}
                                ///>
                            }

                            {
                                //<Autocomplete
                                //    options={projects}
                                //    getOptionLabel={option => option.ProjectTitle + " " + option.ProjectNumber}
                                //    autoComplete
                                //    includeInputInList
                                //    onChange={this.handleProjectSelectChange.bind(this)}
                                //    renderInput={params => (
                                //        <TextField
                                //            {...params}
                                //            label="Select Project"
                                //            margin="normal"
                                //            fullWidth
                                //        />
                                //    )}
                                ///>
                            }

                            <Grid item xs={12} style={{ textAlign: "center" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    className="mt-1"
                                    startIcon={<CloudUploadIcon />}
                                    onClick={this.doUpload.bind(this)}
                                    disabled={isFetching ? true : false}
                                >
                                    Upload
                                </Button>
                            </Grid>

                            <Grid item xs={12} style={{ textAlign: "center", display: isFetching ? "block" : "none" }}>
                                <CircularProgress style={{ display: isFetching ? "block" : "none" }} />
                            </Grid>

                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} className="mt-1">
                    <Card>
                        <CardHeader
                            title="Document Library"
                            className="romis-card-header"
                        ></CardHeader>
                        <CardContent>

                            {
                                //<MUIDataTable
                                //    title={"Documents"}
                                //    data={dataDocs}
                                //    columns={columns}
                                //    options={options}
                                ////actions={[
                                ////    {
                                ////        icon: 'info',
                                ////        tooltip: 'Project Details',
                                ////        onClick: (event, rowData) => {
                                ////            this.props.history.push("/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + `/${rowData.fkUploadedFiles}`);
                                ////        },
                                ////    },
                                ////    {
                                ////        icon: 'info',
                                ////        tooltip: 'Project Monitoring',
                                ////        onClick: (event, rowData) => {
                                ////            this.props.history.push(`/cycleofthereport/${rowData.idProjectDetails}`);
                                ////        },
                                ////    },
                                ////]}
                                ///>
                            }

                            <MaterialTable
                                columns={[
                                    { title: 'idFreeFormFiles', field: 'idFreeFormFiles', hidden: true },
                                    { title: 'Document Title', field: 'DocumentTitle' },
                                    { title: 'Date and Time', field: 'UploadDatetime' },
                                    { title: 'File Category', field: 'FreeFormCategoryName' },
                                    { title: 'fkUploadedFiles', field: 'fkUploadedFiles', hidden: true },
                                    { title: 'OriginalFilename', field: 'OriginalFilename', hidden: true },
                                ]}
                                data={dataDocs}
                                title={"Documents"}
                                //actions={[
                                //    {
                                //        icon: () => <SystemUpdateAltSharpIcon />, // 'info', // <SystemUpdateAltSharpIcon />
                                //        tooltip: 'Download',
                                //        onClick: (event, rowData) => {
                                //            this.handleDoDownloadHrefName("/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + `/${rowData.fkUploadedFiles}`,
                                //                `${rowData.OriginalFilename}`);

                                //            //this.props.history.push("/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + `/${rowData.fkUploadedFiles}`);
                                //        },
                                //    },
                                //    {
                                //        icon: () => <DeleteOutlineIcon />,
                                //        tooltip: 'Delete',
                                //        onClick: (event, rowData) => {
                                //            //this.props.history.push(`/cycleofthereport/${rowData.idFreeFormFiles}`);
                                //            //this.handleFileUploadDeleteConfirmation(`${rowData.idFreeFormFiles}`);
                                //            this.handleFileUploadDeleteConfirmation(rowData.idFreeFormFiles);
                                //        },
                                //    },
                                //]}

                                actions={userType === 2 ? actionsAdmin : actionsNotAdmin}


                                options={{
                                    actionsColumnIndex: -1,
                                    pageSize: 5
                                }}
                            />


                        </CardContent>
                    </Card>
                </Grid>

            </Grid>
        );
    }
}




// WEBPACK FOOTER //
// ./src/pages/UploadFilePage.js